module.exports = "/_next/static/images/little_pool_coffee-d44597c797a9a392d643aa0e0280749c.jpg";